import { render, staticRenderFns } from "./YamlFieldtype.vue?vue&type=template&id=13811b83&"
import script from "./YamlFieldtype.vue?vue&type=script&lang=js&"
export * from "./YamlFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports